import { useSelector } from 'react-redux';

export type Rule = { access_role: string; description: string };

type Result = {
  applicableRules: Rule[];
  effectiveRule: Rule;
};

export default function useAccessRules(
  id: string | number,
  type: string,
  memberId: string | number,
): Result {
  const accessRules = useSelector((state: any) => state.acl.accessRules);
  const effectiveRules = useSelector((state: any) => state.acl.effectiveRules);
  const key = `${type}_${id}_${memberId}`;

  const rules = (accessRules?.[key] || []) as Rule[];
  const effectiveRule = effectiveRules?.[key] as Rule;
  return { applicableRules: rules.slice(0, rules.length), effectiveRule };
}
